import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';

const isAttributeMigrated = (state, elementId, attribute) =>
  state?.[elementId]?.[attribute]?.[breakpointKeys.DEFAULT] === false;

export default isAttributeMigrated;
